import { createSlice } from "@reduxjs/toolkit";
import Token_Usage from "../../pages/ChatGroups_Cust/Token_Usage";

export const initialState = {
  chat_history: [],
  loading: false,
  error_message: false,
  error:true ,
  sequence_id:null,
  ask_bot_response:null,
  ask_bot_error:null,
  ask_bot_loading:false,
  show_sql_popup_button:false,
  show_sql_popup_query:"",
  typing_loader:false,
  streaming_message_time:null,
  transcriptions_loading:false,
  transcription_text:''

};

const Chat_Histoty = createSlice({
  name: "Chat_Histoty",
  initialState,
  reducers: {
    fetch_chat_history_success(state, action) {
       state.chat_history=action.payload
       state.sequence_id = action.payload[0].sequence_id
       state.loading = false;
       state.error = false;

      
    },
    fetch_chat_history_success_append(state, action) {
      state.chat_history=[...action.payload,...state.chat_history]
      state.chat_history.last_id = action.payload.last_id
      state.sequence_id = action.payload[0].sequence_id
      // state.chat_history.has_more = action.payload.has_more
      // state.chat_history.first_id = action.payload.first_id
      state.loading = false;
      state.error = false;

     
   },
    fetch_chat_history_error(state, action) {
      
       
        state.loading = false;
        state.error = true;
        state.error_message = action.payload
    
 
       
     },
     start_chat_loading(state, action) {
         state.loading = true;
     },
     stop_chat_loading(state, action) {
      state.loading = false;
  },
     reset_chat_history(state, action) {
        state.chat_history=[]
        state.sequence_id = null;
        state.loading = false;
        state.error = false;
     },
     ask_bot_success(state, action) {
            state.ask_bot_response = action.payload
            state.ask_bot_loading=false
            state.streaming_message_time = new Date();
         
     },
     ask_bot_fail(state, action) {
        state.ask_bot_error = action.payload
        state.ask_bot_loading=false
 },
 set_sql_popup_button_details(state,action){
   const { popup_open_state , query } = action.payload;
  
   
    state.show_sql_popup_query=query
    state.show_sql_popup_button=popup_open_state
 },
 start_ask_bot_loading(state, action) {

    state.ask_bot_loading=true
    state.ask_bot_response=null

 },
 set_typing_loader(state, action){
   state.typing_loader = action.payload
 },
 start_transcriptions_loading(state, action) {
    state.transcriptions_loading = true
    state.transcription_text = ''
 }
 ,
 set_transcription_text(state, action) {
    state.transcriptions_loading = false
    state.transcription_text = action.payload
 },
 reset_chat_history_whole:()=> initialState




  },
});

export const {
   set_transcription_text,
      start_transcriptions_loading,
      reset_chat_history_whole,
    start_chat_loading,
    fetch_chat_history_error,
    fetch_chat_history_success,
    reset_chat_history,
    ask_bot_success,
    ask_bot_fail,
    start_ask_bot_loading,
    fetch_chat_history_success_append,
    stop_chat_loading,
    set_sql_popup_button_details,
    set_typing_loader
} = Chat_Histoty.actions

export default Chat_Histoty.reducer;